import React from 'react'
import * as i18next from 'i18next'

import Divider from 'app/app/(client)/components/atoms/Divider/Divider'
import Dropdown from 'app/app/(client)/components/molecules/Dropdown/Dropdown'
import SearchBox from 'app/app/(client)/components/molecules/SearchBox/SearchBox'
import { capitalizeIfEnglish } from 'app/app/(client)/utils/utils'
import { filterOptions, sortOptions } from '../../../utils/opportunity-utils'
import { OpportunityFilterOption, OpportunitySortOption } from 'app/types/ui/opportunity'

interface FiltersProps {
  sortKey: OpportunitySortOption
  setSortKey: (val: OpportunitySortOption) => void
  selectedFilterOption: OpportunityFilterOption[]
  setSelectedFilterOption: (val: OpportunityFilterOption[]) => void
  tenderSearch: string
  setTenderSearch: (val: string) => void
  isDisabled?: boolean
}
const Filters: React.FC<FiltersProps> = ({
  sortKey,
  setSortKey,
  selectedFilterOption,
  setSelectedFilterOption,
  tenderSearch,
  setTenderSearch,
  isDisabled = false
}) => {
  const handleFilterDropDownChange = (dropDownKey: string | string[]) => {
    if (Array.isArray(dropDownKey)) {
      const selectedFilterOptionsArr: OpportunityFilterOption[] = []

      dropDownKey.forEach((key: string) => {
        const selected = filterOptions.find(opt => opt.key === key)
        if (selected) {
          selectedFilterOptionsArr.push(selected)
        }
      })
      setSelectedFilterOption(selectedFilterOptionsArr)
    } else {
      const selected = filterOptions.find(opt => opt.key === dropDownKey)
      if (selected) {
        setSelectedFilterOption([selected])
      } else {
        setSelectedFilterOption([])
      }
    }
  }

  const handleSortDropDownChange = (selectionOption: string[]) => {
    if (Array.isArray(selectionOption)) {
      const selectedOption = sortOptions.find(opt => opt.key === selectionOption[0])
      if (selectedOption) {
        setSortKey(selectedOption)
      }
    }
  }

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center gap-3">
      <div className="flex order-2 lg:order-1 gap-3 px-2 lg:px-0 w-full">
        <div className="w-1/2">
          <Dropdown
            id="customer-filter-dropdown"
            iconName="icon-filter text-[18px]"
            className="w-full flex h-9 px-3! py-2! justify-center items-center"
            options={filterOptions.map(opt => ({
              ...opt,
              value: opt.value(i18next.default)
            }))}
            selectedKey={selectedFilterOption.map(f => f.key)}
            onChange={handleFilterDropDownChange}
            isDisable={isDisabled}
            multiselect
            placeholder={capitalizeIfEnglish(i18next.t('customers.filter'))}
            dropDownOptionSize="large"
            renderOption={(option, _isSelected, index) => {
              if (option.disabled) {
                return (
                  <div className="w-full">
                    {index > 2 && <Divider orientation="horizontal" className="divider" />}
                    <div className="px-6 mt-4 mb-1 text-14px text-grey-icon font-bold">{option.value}</div>
                  </div>
                )
              }
              return <div className="text-16px py-3 mr-2 font-normal">{option.value}</div>
            }}
          />
        </div>
        <div className="w-1/2">
          <Dropdown
            id="customer-sort-dropdown"
            iconName="icon-sortable text-[18px]"
            className="w-full flex h-9 px-3! py-2! justify-center items-center"
            options={sortOptions.map(opt => ({
              ...opt,
              value: i18next.t(opt.value)
            }))}
            selectedKey={sortKey ? [sortKey.key] : []}
            onChange={handleSortDropDownChange}
            placeholder={capitalizeIfEnglish(i18next.t('customers.refresh.sort'))}
            isDisable={isDisabled}
            renderOption={(option, _isSelected, index) => {
              if (option.disabled) {
                return (
                  <div className="w-full">
                    {index > 2 && <Divider orientation="horizontal" className="divider" />}
                    <div className="px-2 mt-4 mb-1 text-14px text-grey-icon font-bold">{option.value}</div>
                  </div>
                )
              }
              return <div className="text-16px py-3 mr-2 font-normal">{option.value}</div>
            }}
          />
        </div>
      </div>
      <div className="relative w-full order-1 lg:order-2">
        <SearchBox
          id="customer-searchbox"
          searchQuery={tenderSearch}
          onSearchQueryChange={setTenderSearch}
          placeHolder={capitalizeIfEnglish(i18next.t('customers.search'))}
          isDisabled={isDisabled && tenderSearch === ''}
          className="placeholder:text-[14px] leading-5"
        />
      </div>
    </div>
  )
}

export default React.memo(Filters)
